/*
 * ConfirmationModal Messages
 *
 * This contains all the text for the ConfirmationModal component.
 */

import { defineMessages } from 'react-intl';

export const scope = 'app.components.ConfirmationModal';

export default defineMessages({
  cancel: {
    defaultMessage: 'Cancel',
    id: `${scope}.cancel`,
  },
});
